// usado para a api
export enum TipoMeioPagamentoPedidoApi {
    Boleto = 'BOLETO',
    TransferenciaIntrabancaria = 'TRANSFERENCIA_INTRA',
    TransferenciaInterbancaria = 'TRANSFERENCIA_INTER',
    TransferenciaPix = 'PAGAMENTO_PIX'
}
